// extracted by mini-css-extract-plugin
module.exports = {"icon-link":"Icon_icon-link___0C2q","icon-disabled":"Icon_icon-disabled__D0wbz"};